import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderSlot as _renderSlot, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { tv } from 'tailwind-variants';
import { clsx } from 'clsx';
import { SpriteIcons } from '@/user/components/common/';
import { onMounted, onUnmounted } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ModalWrap',
    props: {
        size: { default: 'small' },
        verticalAlign: { default: 'center' }
    },
    emits: ["close"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const modalWrap = tv({
            slots: {
                wrap: 'bg-dimmed fixed left-0 top-0 z-[var(--zIndex-modal)] flex h-screen w-full justify-center',
                base: clsx('desktop:rounded-12 shadow-modal relative flex w-full flex-col bg-white', 'h-auto max-h-screen desktop:h-auto desktop:max-h-full'),
                closeButton: clsx('absolute right-16 top-16', 'desktop:top-24 desktop:right-24'),
            },
            variants: {
                size: {
                    small: 'desktop:max-w-400 rounded-12',
                    large: 'desktop:max-w-720 desktop:h-auto rounded-none desktop:rounded-12',
                    xlarge: 'desktop:max-w-1200 desktop:h-auto rounded-none desktop:rounded-12',
                },
                verticalAlign: {
                    center: {
                        wrap: 'items-center',
                    },
                    top: {
                        wrap: 'items-start pt-300',
                    },
                    mobileTop: {
                        wrap: 'items-start desktop:items-center',
                    },
                },
            },
        });
        const { wrap, base, closeButton } = modalWrap();
        function handleEscapeKey(event) {
            if (event.key === 'Escape') {
                emit('close');
            }
        }
        function handleBackdropClick(event) {
            if (event.target === event.currentTarget) {
                emit('close');
            }
        }
        onMounted(() => {
            document.addEventListener('keydown', handleEscapeKey);
            document.body.style.overflow = 'hidden';
        });
        onUnmounted(() => {
            document.removeEventListener('keydown', handleEscapeKey);
            document.body.style.overflow = '';
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(_unref(clsx)(_unref(wrap)({ verticalAlign: props.verticalAlign }), props.size === 'small' && 'px-40')),
                role: "dialog",
                "aria-modal": "true",
                onClick: handleBackdropClick
            }, [
                _createElementVNode("div", {
                    id: "modalTop",
                    class: _normalizeClass(_unref(clsx)(_unref(base)({ size: props.size })))
                }, [
                    _renderSlot(_ctx.$slots, "default"),
                    _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(_unref(clsx)(_unref(closeButton)())),
                        onClick: _cache[0] || (_cache[0] = ($event) => (emit('close')))
                    }, [
                        _createVNode(_unref(SpriteIcons), {
                            name: "close",
                            class: "size-24"
                        })
                    ], 2)
                ], 2)
            ], 2));
        };
    }
});
